import { ILineItem } from '~/lib/data-contract';

export const findLineItemIndex = (lineItems: ILineItem[], sku: string): number => {
	return lineItems.findIndex(({ variation }) => variation.sku === sku);
};
